import { NgModule } from "@angular/core";
import { ProjectOverviewComponent } from "./project-overview/project-overview.component";
import { ProjectSettingsOverviewComponent } from './project-settings/project-settings-overview.component';
import { ProjectSchemaComponent } from './project-schema/project-schema.component';
import { ProjectTestAreaComponent } from './project-test-area/project-test-area.component';
import { ProjectStationOverviewComponent } from './project-station-overview/project-station-overview.component';
import { CommonModule } from "@angular/common";

import { MatButtonModule } from "@angular/material/button";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from "@angular/router";
import { ProjectDocumentsComponent } from './project-documents/project-documents.component';
import { ProjectNotesComponent } from './project-notes/project-notes.component';
import { ProjectMenuComponent } from './project-menu/project-menu.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { ProjectRouteStationComponent } from './project-route-station/project-route-station.component';
import { StationMetaInfoComponent } from './shared/components/station-meta-info/station-meta-info.component';
import { ProjectSettingsComponent } from './project-settings/project-settings/project-settings.component';
import { GroupSettingsComponent } from './project-settings/group-settings/group-settings.component';
import { RouteStationSettingsComponent } from './project-settings/route-station-settings/route-station-settings.component';
import { ProjectSettingsCreateModalComponent } from './project-settings/project-settings-create-modal/project-settings-create-modal.component';
import { GroupSettingsCreateModalComponent } from './project-settings/group-settings-create-modal/group-settings-create-modal.component';
import { DataEndChannelTableComponent } from './project-settings/data-end-channel-table/data-end-channel-table.component';
import { RouteStationAddModalComponent } from './project-settings/route-station-add-modal/route-station-add-modal.component';
import { DataEndChannelAddModalComponent } from './project-settings/data-end-channel-add-modal/data-end-channel-add-modal.component';
import { DataEndChannelEditModalComponent } from './project-settings/data-end-channel-edit-modal/data-end-channel-edit-modal.component';
import { SchemaAddStationModalComponent } from './project-schema/schema-add-station-modal/schema-add-station-modal.component';
import { ProjectTimeSwitchComponent } from './project-time-switch/project-time-switch.component';
import { ProjectTimeSwitchNeuComponent } from './project-time-switch-neu/project-time-switch-neu.component';
import { StationAssignDialogComponent } from './project-time-switch-neu/station-assign-dialog/station-assign-dialog.component';
import { TimeSwitchAssignmentPanelComponent } from './project-time-switch-neu/assignment-panel/time-switch-assignment-panel.component';
import { AssignmentConflictDialogComponent } from './project-time-switch-neu/conflict-dialog/assignment-conflict-dialog.component';
import { TimeInputComponent } from "./project-time-switch/shared/time-input/time-input.component";
import { CdkDropListGroup, CdkDragDrop, CdkDrag, CdkDropList, moveItemInArray, transferArrayItem, DragDropModule } from "@angular/cdk/drag-drop";
import { ProjectImagesComponent } from './project-images/project-images.component';
import { SetImageModalComponent } from './project-images/set-image-modal/set-image-modal.component';
import { MatDialogModule } from "@angular/material/dialog";
import { SchemaRouteStationModalComponent } from './project-schema/schema-route-station-modal/schema-route-station-modal.component';
import { ProjectSettingsMapComponent } from './project-settings/project-settings-map/project-settings-map.component';
import { UserModule } from "../user/user.module";
import { MatTooltipModule } from '@angular/material/tooltip';
import { UploadImageModalComponent } from './project-images/upload-image-modal/upload-image-modal.component';
import { AddAqTimeSwitchComponent } from './project-time-switch/project-time-switch-add-modal/add-aq-time-switch/add-aq-time-switch.component';
import { AddMqTimeSwitchComponent } from './project-time-switch/project-time-switch-add-modal/add-mq-time-switch/add-mq-time-switch.component';
import { ProjectTimeSwitchAddModalWrapperComponent } from './project-time-switch/project-time-switch-add-modal/project-time-switch-add-modal-wrapper/project-time-switch-add-modal-wrapper.component';
import { PopupRangePickerComponent } from './project-time-switch/shared/popup-range-picker/popup-range-picker.component';
import { ProjectSwaConfigComponent } from './project-swa-config/project-swa-config.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AddTimeSwitchComponent } from './project-time-switch/project-time-switch-add-modal/add-time-switch/add-time-switch.component';
import { DatePipe } from "@angular/common";
import { MatSelectModule } from '@angular/material/select';
import { TestAreaBrightnessComponent } from "./project-test-area/test-area-brightness/test-area-brightness.component";
import { TestAreaImageSettingsComponent } from "./project-test-area/test-area-image-settings/test-area-image-settings.component";
import { TestAreaAdditionalSettingsComponent } from "./project-test-area/test-area-additional-settings/test-area-additional-settings.component";
import { TestAreaDigitalOutputsComponent } from "./project-test-area/test-area-digital-outputs/test-area-digital-outputs.component";
import { AddFlasherTimeSwitchComponent } from './project-time-switch/project-time-switch-add-modal/add-flasher-time-switch/add-flasher-time-switch.component';
import { ErrorDialogComponent } from './project-time-switch/error-dialog/error-dialog.component';
import { LineNameComponent } from './project-schema/shared/components/line-name/line-name.component';
import { VoltageChartComponent } from "./project-schema/shared/components/voltage-chart/voltage-chart.component";
import { EnergyChartComponent } from "./project-schema/shared/components/energy-chart/energy-chart.component";
import { ProjectTimeSwitchEditModalWrapperComponent } from './project-time-switch/project-time-switch-edit-modal-wrapper/project-time-switch-edit-modal-wrapper.component';
import { DataEndChannelSettingsDialogComponent } from './project-settings/shared/data-end-channel-settings-dialog/data-end-channel-settings-dialog.component';
import { RadarDataChartComponent } from './project-schema/shared/components/radar-data-chart/radar-data-chart.component';
import { FileUploadModalComponent } from './project-documents/shared/file-upload-modal/file-upload-modal.component';
import { CurrentChartComponent } from './project-schema/shared/components/current-chart/current-chart.component';
//import { FuelcellCurrentsDiagramComponent} from './project-schema/shared/components/fuelcell-currents-diagram/fuelcell-currents-diagram.component';
import { TestAreaSmartMicroComponent } from './project-test-area/test-area-smart-micro/test-area-smart-micro.component';
import { ProjectScenarioComponent } from './project-scenario/project-scenario.component';
import { AddScenarioDialogComponent } from './project-scenario/add-scenario-dialog/add-scenario-dialog.component';
import { ScenarioSelectDialogComponent } from './project-schema/scenario-select-dialog/scenario-select-dialog.component';
import { ModularRouteStationComponent } from './project-scenario/modular-route-station/modular-route-station.component';
import { AnimatedImageModalComponent } from './project-settings/project-settings/animated-image-modal/animated-image-modal.component';
import { ProjectScenarioRouteStationModulComponent } from './project-scenario/modular-route-station/project-scenario-route-station-modul/project-scenario-route-station-modul.component';
import { AnimatedImagesErrorDialogComponent } from './project-settings/project-settings/animated-images-error-dialog/animated-images-error-dialog.component';
import { StmChartComponent } from './project-schema/shared/components/stm-chart/stm-chart.component';
import { ManualControlResultComponent } from './project-scenario/manual-control-result/manual-control-result.component';
import { GroupStellcodeDeleteDialogComponent } from './project-settings/project-settings/group-stellcode-delete-dialog/group-stellcode-delete-dialog.component';
import { MatTabsModule } from '@angular/material/tabs';
import { SpeedChartComponent } from './project-schema/shared/components/speed-chart/speed-chart.component';
import { OderByPipe } from './shared/pipes/oder-by.pipe';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { SolarDetailsComponent } from './project-schema/shared/components/solar-details/solar-details.component';
import { FallbackImageSettingsComponent } from './project-settings/shared/fallback-image-settings/fallback-image-settings.component';
import { BrennstoffzellenHistoryComponent } from './project-schema/shared/components/brennstoffzellen-history/brennstoffzellen-history.component';
import { MtxTooltipModule } from '@ng-matero/extensions/tooltip';
import { MatIconModule } from "@angular/material/icon";
import { WorkloadDiagrammComponent } from "../report/shared/components/workload-diagramm/workload-diagramm.component";
import { BrennstoffzellenDetailsComponent } from './project-schema/shared/components/brennstoffzellen-details/brennstoffzellen-details.component';
import { EvaResetComponent } from './shared/components/eva-reset/eva-reset.component';
import { ProjectGooglemapsComponent } from './project-googlemaps/project-googlemaps.component';
import { SensorSettingsComponent } from './project-settings/shared/sensor-settings/sensor-settings.component';
import { BilderkatalogComponent } from './shared/components/bilderkatalog/bilderkatalog.component';
import { FallbackFlasherSettingsComponent } from './project-settings/shared/fallback-flasher-settings/fallback-flasher-settings.component';
import { SwaLineParameterComponent } from './project-swa-config/shared/components/swa-line-parameter/swa-line-parameter.component';
import { RouteStationsLineParamComponent } from './project-swa-config/shared/components/route-stations-line-param/route-stations-line-param.component';
import { DataEndChannelLineParamDialogComponent } from './project-swa-config/shared/components/data-end-channel-line-param-dialog/data-end-channel-line-param-dialog.component';
import { CreateEditErrorTresholdComponent } from "./project-settings/data-end-channel-table/shared/create-edit-error-treshold/create-edit-error-treshold.component";
import { PixelFehlerDialogComponent } from "./project-settings/data-end-channel-table/shared/pixel-fehler-dialog/pixel-fehler-dialog.component";
import { DeviceInfoDialogComponent } from "./project-settings/data-end-channel-table/shared/device-info-dialog/device-info-dialog.component";
import { AddDoTimeSwitchComponent } from "./project-time-switch/project-time-switch-add-modal/add-do-time-switch/add-do-time-switch.component";
import { SetDoControlComponent } from "./project-schema/shared/components/set-do-control/set-do-control.component";
import { SetDiControlComponent } from "./project-schema/shared/components/set-di-control/set-di-control.component";
import { SetMqControlComponent } from "./project-schema/shared/components/set-mq-control/set-mq-control.component";
import { SetAqControlComponent } from "./project-schema/shared/components/set-aq-control/set-aq-control.component";
import { SetBarrierControlComponent } from "./project-schema/shared/components/set-barrier-control/set-barrier-control.component";
import { SetFlasherControlComponent } from "./project-schema/shared/components/set-flasher-control/set-flasher-control.component";
import { CameraViewModalComponent } from "./project-schema/shared/components/camera-view-modal/camera-view-modal.component";
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ProjectTrafficMonitoringComponent } from "./project-traffic-monitoring/project-traffic-monitoring.component";
import { CameraAlarmPopUpComponent } from "./project-schema/shared/components/camera-alarm-pop-up/camera-alarm-pop-up.component";
import { VideoPlayerComponent } from "./project-traffic-monitoring/video-player/video-player.component";
import { RtspPlayerComponent } from "./shared/components/rtsp-player/rtsp-player.component";
import { AxisRtspPlayerComponent } from "./shared/components/axis-rtsp-player-service/axis-rtsp-player-service.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DigitalInputEngineParameterSettingsDialogComponent } from "./project-settings/shared/digital-input-engine-parameter-settings-dialog/digital-input-engine-parameter-settings-dialog.component";
import { WeatherConfigSettingsComponent } from "./project-settings/weather-config-settings/weather-config-settings.component";
import { FuelcellControlSettingsComponent } from "./project-settings/fuelcell-control-settings/fuelcell-control-settings.component";
import { FuelcellSystemStateSettingsComponent } from "./project-settings/fuelcell-control-settings/fuelcell-system-state-settings/fuelcell-system-state-settings.component";
import { FuelcellCartridgeSettingsComponent } from "./project-settings/fuelcell-control-settings/fuelcell-cartridge-settings/fuelcell-cartridge-settings.component";
import { FuelcellBatterySettingsComponent } from "./project-settings/fuelcell-control-settings/fuelcell-battery-settings/fuelcell-battery-settings.component";
import { FuelcellSensorSettingsComponent } from "./project-settings/fuelcell-control-settings/fuelcell-sensor-settings/fuelcell-sensor-settings.component";
import { ProjectSwaVisualisierungComponent } from './project-swa-visualisierung/project-swa-visualisierung.component';
import { WeatherDataDetailsComponent } from './project-schema/shared/components/weatherData-details/weatherData-details.component';
import { WeatherDataChartComponent } from './project-schema/shared/components/weatherData-chart/weatherData-chart.component';
import { DateAdapter, MAT_DATE_LOCALE, NativeDateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

export class GermanDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
    return super.format(date, displayFormat);
  }
}

export const GERMAN_DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'input',            // -> triggert dein format()
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({

  declarations: [
    ProjectOverviewComponent,
    ProjectSettingsOverviewComponent,
    ProjectSchemaComponent,
    ProjectTestAreaComponent,
    ProjectStationOverviewComponent,
    ProjectDocumentsComponent,
    ProjectNotesComponent,
    ProjectMenuComponent,
    ProjectRouteStationComponent,
    StationMetaInfoComponent,
    ProjectSettingsComponent,
    GroupSettingsComponent,
    RouteStationSettingsComponent,
    ProjectSettingsCreateModalComponent,
    GroupSettingsCreateModalComponent,
    DataEndChannelTableComponent,
    RouteStationAddModalComponent,
    DataEndChannelAddModalComponent,
    DataEndChannelEditModalComponent,
    SchemaAddStationModalComponent,
    ProjectTimeSwitchComponent,
    TimeInputComponent,
    SchemaRouteStationModalComponent,
    SetImageModalComponent,
    SchemaRouteStationModalComponent,
    ProjectSettingsMapComponent,
    UploadImageModalComponent,
    ProjectImagesComponent,
    AddAqTimeSwitchComponent,
    AddMqTimeSwitchComponent,
    ProjectTimeSwitchAddModalWrapperComponent,
    ProjectSwaConfigComponent,
    AddTimeSwitchComponent,
    TestAreaBrightnessComponent,
    TestAreaImageSettingsComponent,
    TestAreaAdditionalSettingsComponent,
    TestAreaDigitalOutputsComponent,
    AddFlasherTimeSwitchComponent,
    ErrorDialogComponent,
    LineNameComponent,
    VoltageChartComponent,
    EnergyChartComponent,
    ProjectTimeSwitchEditModalWrapperComponent,
    ProjectTimeSwitchNeuComponent,
    StationAssignDialogComponent,
    TimeSwitchAssignmentPanelComponent,
    AssignmentConflictDialogComponent,
    DataEndChannelSettingsDialogComponent,
    RadarDataChartComponent,
    CurrentChartComponent,
    TestAreaSmartMicroComponent,
    FileUploadModalComponent,
    ProjectScenarioComponent,
    AddScenarioDialogComponent,
    ScenarioSelectDialogComponent,
    ModularRouteStationComponent,
    AnimatedImageModalComponent,
    TestAreaSmartMicroComponent,
    ProjectScenarioRouteStationModulComponent,
    AnimatedImagesErrorDialogComponent,
    StmChartComponent,
    ManualControlResultComponent,
    GroupStellcodeDeleteDialogComponent,
    SpeedChartComponent,
    OderByPipe,
    SolarDetailsComponent,
    WorkloadDiagrammComponent,
    BrennstoffzellenDetailsComponent,
    EvaResetComponent,
    ProjectGooglemapsComponent,
    FallbackImageSettingsComponent,
    EvaResetComponent,
    BrennstoffzellenHistoryComponent,
    SensorSettingsComponent,
    BilderkatalogComponent,
    FallbackFlasherSettingsComponent,
    RouteStationsLineParamComponent,
    SwaLineParameterComponent,
    DataEndChannelLineParamDialogComponent,
    CreateEditErrorTresholdComponent,
    PixelFehlerDialogComponent,
    DeviceInfoDialogComponent,
    AddDoTimeSwitchComponent,
    SetDoControlComponent,
    SetDiControlComponent,
    SetMqControlComponent,
    SetAqControlComponent,
    SetFlasherControlComponent,
    SetBarrierControlComponent,
    CameraViewModalComponent,
    ProjectTrafficMonitoringComponent,
    CameraAlarmPopUpComponent,
    VideoPlayerComponent,
    RtspPlayerComponent,
    AxisRtspPlayerComponent,
    DigitalInputEngineParameterSettingsDialogComponent,
    WeatherConfigSettingsComponent,
    FuelcellControlSettingsComponent,
    FuelcellSystemStateSettingsComponent,
    FuelcellCartridgeSettingsComponent,
    FuelcellBatterySettingsComponent,
    FuelcellSensorSettingsComponent,
    ProjectSwaVisualisierungComponent,
    WeatherDataDetailsComponent,
    WeatherDataChartComponent
  ],
  imports: [
    MatButtonModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatCheckboxModule,
    CommonModule,
    MatButtonModule,
    MatSlideToggleModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CdkDrag,
    CdkDropList,
    CdkDropListGroup,
    MatDialogModule,
    UserModule,
    MatTooltipModule,
    PopupRangePickerComponent,
    DatePipe,
    MatCheckboxModule,
    MatSelectModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    BrowserAnimationsModule,
    MtxTooltipModule,
    MatIconModule,
    DragDropModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule


  ],
  exports: [
    ProjectMenuComponent,
    ProjectRouteStationComponent,
    RouteStationSettingsComponent,
    TestAreaBrightnessComponent,
    TestAreaImageSettingsComponent,
    TestAreaAdditionalSettingsComponent,
    TestAreaDigitalOutputsComponent
  ],
  providers: [{ provide: DateAdapter, useClass: GermanDateAdapter, deps: [MAT_DATE_LOCALE] },
  { provide: MAT_DATE_FORMATS, useValue: GERMAN_DATE_FORMATS },
  { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },],
})
export class ProjectModule { }
